import { AVAILABLE_LANGUAGE } from "../components/Header/header.constants";
import messages_en from './translations/en.json';
import messages_pl from './translations/pl.json';
import messages_ua from './translations/ua.json';

export const APP_MESSAGES = {
    [AVAILABLE_LANGUAGE.EN]: messages_en,
    [AVAILABLE_LANGUAGE.PL]: messages_pl,
    [AVAILABLE_LANGUAGE.UA]: messages_ua,
}